import { render, staticRenderFns } from "./customerLabel.vue?vue&type=template&id=a332ad94&scoped=true"
import script from "./customerLabel.vue?vue&type=script&lang=js"
export * from "./customerLabel.vue?vue&type=script&lang=js"
import style0 from "./customerLabel.vue?vue&type=style&index=0&id=a332ad94&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a332ad94",
  null
  
)

export default component.exports